type IQueryParamTypes = number | string | boolean | null;

export const getParametrizedUrl = (url: string, params?: { [key: string]: IQueryParamTypes }, query?: { [key: string]: IQueryParamTypes }) => {
	let resultUrl = url.replace(/\/\?$/, '');

	if (params) {
		Object.keys(params)
			.forEach((key: string) => resultUrl = resultUrl.replace(new RegExp(`:${key}`, 'g'), String(params[key])));
	}

	if (query && Object.keys(query).length) {
		resultUrl += '?' + Object.keys(query)
			.filter((key: string) => !!query[key])
			.map((key: string) => `${key}=${encodeURIComponent(String(query[key]))}`)
			.join('&');
	}

	return resultUrl;
};